import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-entry',
  template: ''
})
export class EntryComponent implements OnInit {

  constructor(private router: Router){

  }

  ngOnInit() {
    var theURL = window.location.pathname;
    var urltab = theURL.split('/');
    window.location.href = urltab[0] + '/connect.html';
  }
}



// WEBPACK FOOTER //
// ./src/app/page/entry/entry.component.ts